// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"zr-z","badgeLink":"Ar-z","category":"Br-z"};